import moment from 'moment';
import format from 'date-fns/format';
import { QuestionTextField, QuestionJurisdictionDropDownField, QuestionDateDropdownField } from 'components/Questionnaires/fields';
import { QuestionAddressBlock, QuestionSignerBlock, QuestionUsTinBlock, QuestionForeignTinBlock, QuestionTreatyClaimBlock } from 'components/Questionnaires/blocks';
import { requiredValidator } from 'components/Questionnaires/validators';

const w8Ben = {
  blocks: [
    {
      id: 'name',
      title: 'questionnaire.W8Ben.name',
      component: undefined, // Component for Block
      info: {
        instructions: 'questionnaire.W8Ben.name.name.info'
      },
      visible: true,
      questions: [
        {
          id: 'name',
          label: 'questionnaire.W8Ben.name.name.label',
          component: QuestionTextField,
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.W8Ben.name.name.errorMessage' }
            ]
          }
        },
      ]
    },
    {
      id: 'citizenshipCountry',
      title: 'questionnaire.W8Ben.citizenshipCountry',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'country',
          label: 'questionnaire.W8Ben.citizenshipCountry.label',
          component: QuestionJurisdictionDropDownField,
          info: {
            instructions: 'questionnaire.citizenshipCountry.info'
          },
          visible: true,
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.W8Ben.citizenshipCountry.errorMessage' }
            ]
          }
        },
      ],
    },
    {
      id: 'address',
      title: 'questionnaire.address',
      component: QuestionAddressBlock,
      info: {
        instructions: 'questionnaire.address.1.info'
      },
      visible: true,
      lockGroup: 'permanentAddress',
    },
    {
      id: 'mailingAddress',
      title: 'questionnaire.mailingAddress',
      component: QuestionAddressBlock,
      componentProps: {
        line1Label: 'questionnaire.mailingAddress.1.label',
        optional: true
      },
      info: {
        instructions: 'questionnaire.mailingAddress.1.info'
      },
      visible: true,
      linkBlock: true,
      lockGroup: 'mailingAddress',
    },
    {
      id: 'foreignTin',
      title: 'questionnaire.foreignTin',
      component: QuestionForeignTinBlock,
      visible: true,
    },
    {
      id: 'usTin',
      title: 'questionnaire.usTin',
      component: QuestionUsTinBlock,
      componentProps: {
        showAppliedFor: false,
        tinRequired: false
      },
      visible: true
    },
    {
      id: 'birth',
      title: 'questionnaire.W8Ben.birth',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'date',
          label: 'questionnaire.W8Ben.birth.date.label',
          component: QuestionDateDropdownField,
          componentProps: {
            minDate: format(moment().subtract(125, 'years').toDate(), 'MM-dd-yyyy'),
            maxDate: format(moment().subtract(1, 'days').toDate(), 'MM-dd-yyyy'),
            dateFormat: 'MM-dd-yyyy',
            showToolTip: true
          },
          info: {
            instructions: 'questionnaire.birth.date.info'
          },
          className: 'col-12',
          visible: true,
          lockGroup: 'dateOfBirth',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.birth.date.errorMessage' }
            ]
          },
        },
      ]
    },
    {
      id: 'treatyClaim',
      title: 'questionnaire.treatyClaim',
      component: QuestionTreatyClaimBlock,
      visible: true,
    },
    {
      id: 'signer',
      title: 'questionnaire.signer',
      component: QuestionSignerBlock,
      componentProps: {
        individualOnly: true
      },
      visible: true
    },
  ]
};

export default w8Ben;
